// Nirogam India: one-tap "Add" for the cart drawer upsell (snippets/ni-cart-upsell.liquid).
// Follows the product-form.js pattern so the cart drawer, cart icon and analytics update without a reload.
// If anything fails, it falls back to the plain /cart/add form POST.
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-ni-upsell')) return;
  event.preventDefault();

  const button = form.querySelector('button');
  if (button) button.disabled = true;

  const variantId = String(new FormData(form).get('id'));
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : ''))
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();

  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const addResponse = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
    });
    const added = await addResponse.json();
    if (!addResponse.ok || added.status) throw new Error(added.description || added.message || 'Add to cart failed');

    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
      r.json()
    );
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { sections: added.sections, items: cart.items, itemCount: 1, source: 'ni-cart-upsell' },
    });
  } catch (error) {
    deferred.reject(error);
    form.submit();
  }
});
